export interface DevicePreferences {
  videoEnabled: boolean;
  audioEnabled: boolean;
  videoDeviceId?: string | undefined;
  audioDeviceId?: string | undefined;
}

const KEY = 'apovisio.devices.v1';
const DEFAULTS: DevicePreferences = { videoEnabled: true, audioEnabled: true };

/** Préférences de périphériques propres à ce navigateur (confort uniquement). */
export function loadDevicePreferences(): DevicePreferences {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw) as Partial<DevicePreferences>;
    return {
      videoEnabled: parsed.videoEnabled !== false,
      audioEnabled: parsed.audioEnabled !== false,
      videoDeviceId: typeof parsed.videoDeviceId === 'string' ? parsed.videoDeviceId : undefined,
      audioDeviceId: typeof parsed.audioDeviceId === 'string' ? parsed.audioDeviceId : undefined,
    };
  } catch {
    return DEFAULTS;
  }
}

export function saveDevicePreferences(preferences: DevicePreferences): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(preferences));
  } catch {
    // Stockage indisponible (navigation privée) : sans conséquence.
  }
}
